// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* "Message limit reached" modal — styled to match the playground locked card
   (chatModal \`.chat-locked-*\`): a centered gradient lock badge + title +
   subtitle, then one clean card per bot that hit its monthly limit. */
.lec-modal.modal-content {
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #fff;
  border-radius: 10px;
  text-align: left;
}

/* ── Hero header (mirrors .chat-locked-card) ── */
.lec-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 6px 8px 0;
}
.lec-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6a2bff 0%, #5616ea 100%);
  color: #fff;
  font-size: 22px;
  box-shadow: 0 10px 22px -6px rgba(86, 22, 234, 0.55);
}
.lec-hero-title {
  margin: 18px 0 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #1d1b2e;
}
.lec-hero-sub {
  margin: 8px 0 0;
  max-width: 340px;
  font-size: 14px;
  line-height: 1.5;
  color: #6b6b78;
}

/* ── Per-bot cards ── */
.lec-rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.lec-row {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #efeafd;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(20, 10, 50, 0.04);
}
.lec-row-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.lec-bot-name {
  font-weight: 700;
  font-size: 15px;
  color: #1d1b2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lec-plan-badge {
  flex-shrink: 0;
  background: #f4f0ff;
  border: 1px solid #d9c9ff;
  color: #5616ea;
  padding: 3px 12px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Usage bar — full (100%) at the limit; brand gradient keeps it on-tone with
   the playground card rather than an alarm-red. */
.lec-progress {
  position: relative;
  height: 7px;
  width: 100%;
  background: #f0ecfb;
  border-radius: 999px;
  overflow: hidden;
}
.lec-progress-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 999px;
  background: linear-gradient(90deg, #6a2bff 0%, #5616ea 100%);
}

.lec-row-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.lec-usage-numbers {
  font-size: 13px;
  font-weight: 600;
  color: #6b6b78;
}

/* Upgrade CTA — mirrors .chat-locked-btn (gradient + soft purple glow). */
.lec-upgrade-btn {
  flex-shrink: 0;
  border: none;
  cursor: pointer;
  padding: 9px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #6a2bff 0%, #5616ea 100%);
  box-shadow: 0 10px 22px -8px rgba(86, 22, 234, 0.6);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}
.lec-upgrade-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 26px -8px rgba(86, 22, 234, 0.7);
  filter: brightness(1.03);
}
.lec-upgrade-btn:active {
  transform: translateY(0);
}

@media (max-width: 480px) {
  .lec-hero-sub { max-width: 100%; }
  .lec-hero-title { font-size: 20px; }
}

/* ───────────────────────────────────────────────────────────────────────────
   Shared button classes. Defined ONLY here but used app-wide by the register
   pages (Webflow/WordPress) and paymentPastDueModal — keep them in sync, do
   NOT delete even though this modal no longer uses them.
   ─────────────────────────────────────────────────────────────────────────── */
.close-modal-button {
  position: absolute !important;
  right: 24px;
  top: 16px;
  background-color: transparent !important;
  border: none !important;
  outline: none !important;
  cursor: pointer;
  font-size: 22px;
  color: #5616ea !important;
  padding: 0;
  margin: 0;
  transition: transform 0.2s ease, color 0.2s ease;
}
.close-modal-button:hover {
  transform: scale(1.15);
}

.continue-button {
  border-radius: 8px;
  outline: none;
  padding: 6px 12px;
  background-color: #5616ea;
  border: none;
  color: white;
  cursor: pointer;
  transition: background-color 0.25s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  font-size: 13px;
  font-weight: 600;
}
.continue-button:hover {
  background-color: #4a14d6;
  transform: translateY(-1px);
}
.continue-button:active {
  transform: translateY(0);
}

.close-button {
  background: #ccc;
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}
.close-button:hover {
  background: #bfbfbf;
  transform: translateY(-1px);
}
.close-button:active {
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/components/limitExceededModal.css"],"names":[],"mappings":"AAAA;;sEAEsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,oDAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;kDACkD;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,oBAAoB;EACpB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,mDAAmD;EACnD,0EAA0E;AAC5E;AACA;EACE,2BAA2B;EAC3B,mDAAmD;EACnD,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB,eAAe,EAAE;EACjC,kBAAkB,eAAe,EAAE;AACrC;;AAEA;;;;gFAIgF;AAChF;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,wCAAwC;EACxC,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,SAAS;EACT,gDAAgD;AAClD;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kFAAkF;EAClF,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2EAA2E;AAC7E;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":["/* \"Message limit reached\" modal — styled to match the playground locked card\r\n   (chatModal `.chat-locked-*`): a centered gradient lock badge + title +\r\n   subtitle, then one clean card per bot that hit its monthly limit. */\r\n.lec-modal.modal-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  text-align: left;\r\n}\r\n\r\n/* ── Hero header (mirrors .chat-locked-card) ── */\r\n.lec-hero {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  padding: 6px 8px 0;\r\n}\r\n.lec-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #6a2bff 0%, #5616ea 100%);\r\n  color: #fff;\r\n  font-size: 22px;\r\n  box-shadow: 0 10px 22px -6px rgba(86, 22, 234, 0.55);\r\n}\r\n.lec-hero-title {\r\n  margin: 18px 0 0;\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  letter-spacing: -0.01em;\r\n  color: #1d1b2e;\r\n}\r\n.lec-hero-sub {\r\n  margin: 8px 0 0;\r\n  max-width: 340px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: #6b6b78;\r\n}\r\n\r\n/* ── Per-bot cards ── */\r\n.lec-rows {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n.lec-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding: 14px 16px;\r\n  border: 1px solid #efeafd;\r\n  border-radius: 14px;\r\n  background: #fff;\r\n  box-shadow: 0 2px 8px rgba(20, 10, 50, 0.04);\r\n}\r\n.lec-row-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n.lec-bot-name {\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  color: #1d1b2e;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.lec-plan-badge {\r\n  flex-shrink: 0;\r\n  background: #f4f0ff;\r\n  border: 1px solid #d9c9ff;\r\n  color: #5616ea;\r\n  padding: 3px 12px;\r\n  border-radius: 999px;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Usage bar — full (100%) at the limit; brand gradient keeps it on-tone with\r\n   the playground card rather than an alarm-red. */\r\n.lec-progress {\r\n  position: relative;\r\n  height: 7px;\r\n  width: 100%;\r\n  background: #f0ecfb;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n}\r\n.lec-progress-bar {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  border-radius: 999px;\r\n  background: linear-gradient(90deg, #6a2bff 0%, #5616ea 100%);\r\n}\r\n\r\n.lec-row-foot {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n.lec-usage-numbers {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #6b6b78;\r\n}\r\n\r\n/* Upgrade CTA — mirrors .chat-locked-btn (gradient + soft purple glow). */\r\n.lec-upgrade-btn {\r\n  flex-shrink: 0;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 9px 24px;\r\n  border-radius: 10px;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  background: linear-gradient(135deg, #6a2bff 0%, #5616ea 100%);\r\n  box-shadow: 0 10px 22px -8px rgba(86, 22, 234, 0.6);\r\n  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\r\n}\r\n.lec-upgrade-btn:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 12px 26px -8px rgba(86, 22, 234, 0.7);\r\n  filter: brightness(1.03);\r\n}\r\n.lec-upgrade-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .lec-hero-sub { max-width: 100%; }\r\n  .lec-hero-title { font-size: 20px; }\r\n}\r\n\r\n/* ───────────────────────────────────────────────────────────────────────────\r\n   Shared button classes. Defined ONLY here but used app-wide by the register\r\n   pages (Webflow/WordPress) and paymentPastDueModal — keep them in sync, do\r\n   NOT delete even though this modal no longer uses them.\r\n   ─────────────────────────────────────────────────────────────────────────── */\r\n.close-modal-button {\r\n  position: absolute !important;\r\n  right: 24px;\r\n  top: 16px;\r\n  background-color: transparent !important;\r\n  border: none !important;\r\n  outline: none !important;\r\n  cursor: pointer;\r\n  font-size: 22px;\r\n  color: #5616ea !important;\r\n  padding: 0;\r\n  margin: 0;\r\n  transition: transform 0.2s ease, color 0.2s ease;\r\n}\r\n.close-modal-button:hover {\r\n  transform: scale(1.15);\r\n}\r\n\r\n.continue-button {\r\n  border-radius: 8px;\r\n  outline: none;\r\n  padding: 6px 12px;\r\n  background-color: #5616ea;\r\n  border: none;\r\n  color: white;\r\n  cursor: pointer;\r\n  transition: background-color 0.25s ease, transform 0.2s ease, box-shadow 0.2s ease;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n}\r\n.continue-button:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n.continue-button:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.close-button {\r\n  background: #ccc;\r\n  padding: 8px 14px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n.close-button:hover {\r\n  background: #bfbfbf;\r\n  transform: translateY(-1px);\r\n}\r\n.close-button:active {\r\n  transform: translateY(0);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
